<template>
  <section class="content">
    <div class="row">
      <div class="col-md-12">
        <div class="box box-primary">
          <div class="box-header with-border">
            <h3 class="box-title">
              <b>Nova Empresa</b>
            </h3>
          </div>
          <div class="box-body">
            <div class="row">
              <div class="col-sm-2">
                <div :class="{'form-group': true, 'has-error':errors.has('cnpj') }">
                  <label for="cnpj" style>CNPJ</label>
                  <input
                    v-mask="['##.###.###/####-##']"
                    class="form-control"
                    name="cnpj"
                    type="text"
                    v-model="dados.cnpj"
                    v-validate="'required'"
                  >
                  <span v-show="errors.has('cnpj')" class="help-block">Campo obrigatório</span>
                </div>
              </div>
              <div class="col-sm-4">
                <div :class="{'form-group': true, 'has-error':errors.has('razao') }">
                  <label for="razao">Razão Social</label>
                  <input
                    class="form-control"
                    name="razao"
                    type="text"
                    v-model="dados.razao"
                    v-validate="'required'"
                    ref="razao"
                  >
                  <span v-show="errors.has('razao')" class="help-block">Campo obrigatório</span>
                </div>
              </div>
              <div class="col-sm-4">
                <div :class="{'form-group': true, 'has-error':errors.has('fantasia') }">
                  <label for="fantasia">Fantasia</label>
                  <input
                    class="form-control"
                    name="fantasia"
                    type="text"
                    v-model="dados.fantasia"
                    v-validate="'required'"
                    ref="fantasia"
                  >
                  <span v-show="errors.has('fantasia')" class="help-block">Campo obrigatório</span>
                </div>
              </div>
              <div class="col-sm-2">
                <div class="form-group">
                  <label for="insc_estadual">Insc. Estadual</label>
                  <input
                    class="form-control"
                    name="insc_estadual"
                    type="text"
                    v-model="dados.insc_estadual"
                  >
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-sm-2">
                <div :class="{'form-group': true, 'has-error':errors.has('cep') }">
                  <label for="cep">CEP</label>
                  <input
                    class="form-control"
                    name="cep"
                    type="text"
                    v-model="dados.cep"
                    v-validate="'required'"
                    v-mask="'#####-###'"
                    @blur="getEndereco"
                  >
                  <span v-show="errors.has('cep')" class="help-block">Campo obrigatório</span>
                </div>
              </div>

              <div class="col-sm-5">
                <div :class="{'form-group': true, 'has-error':errors.has('endereco') }">
                  <label for="endereco">Endereço</label>
                  <input
                    class="form-control"
                    name="endereco"
                    type="text"
                    v-model="dados.endereco"
                    v-validate="'required'"
                  >
                  <span v-show="errors.has('endereco')" class="help-block">Campo obrigatório</span>
                </div>
              </div>

              <div class="col-sm-2">
                <div :class="{'form-group': true, 'has-error':errors.has('numero') }">
                  <label for="numero">Número</label>
                  <input
                    class="form-control"
                    name="numero"
                    type="text"
                    v-model="dados.numero"
                    v-validate="'required'"
                    ref="numero_endereco"
                  >
                  <span v-show="errors.has('numero')" class="help-block">Campo obrigatório</span>
                </div>
              </div>
              <div class="col-sm-3">
                <div :class="{'form-group': true, 'has-error':errors.has('complemento') }">
                  <label for="complemento">Complemento</label>
                  <input
                    class="form-control"
                    name="complemento"
                    type="text"
                    v-model="dados.complemento"
                  >
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-5">
                <div :class="{'form-group': true, 'has-error':errors.has('bairro') }">
                  <label for="bairro">Bairro</label>
                  <input
                    class="form-control"
                    name="bairro"
                    type="text"
                    v-model="dados.bairro"
                    v-validate="'required'"
                  >
                  <span v-show="errors.has('bairro')" class="help-block">Campo obrigatório</span>
                </div>
              </div>

              <div class="col-sm-5">
                <div :class="{'form-group': true, 'has-error':errors.has('cidade') }">
                  <label for="cidade">Cidade</label>
                  <input
                    class="form-control"
                    name="cidade"
                    type="text"
                    v-model="dados.cidade"
                    v-validate="'required'"
                  >
                  <span v-show="errors.has('cidade')" class="help-block">Cidade</span>
                </div>
              </div>

              <div class="col-sm-2">
                <div :class="{'form-group': true, 'has-error':errors.has('uf') }">
                  <label for="uf">Estado</label>
                  <input
                    class="form-control"
                    name="uf"
                    type="text"
                    v-model="dados.uf"
                    v-validate="'required'"
                  >
                  <span v-show="errors.has('uf')" class="help-block">Campo obrigatório</span>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6">
                <div class="form-group">
                  <label for="email">Email</label>
                  <input class="form-control" name="email" type="text" v-model="dados.email">
                </div>
              </div>
              <div class="col-sm-2">
                <div class="form-group">
                  <label for="tel1">Telefone 1</label>
                  <input class="form-control" name="tel1" type="text" v-model="dados.tel1" v-mask="['(##)####-####','(##)#####-####']">
                </div>
              </div>
              <div class="col-sm-2">
                <div class="form-group">
                  <label for="tel2">Telefone 2</label>
                  <input class="form-control" name="tel2" type="text" v-model="dados.tel2" v-mask="['(##)####-####','(##)#####-####']">
                </div>
              </div>
              <div class="col-sm-2">
                <div class="form-group">
                  <label for="tel3">Telefone 3</label>
                  <input class="form-control" name="tel3" type="text" v-model="dados.tel3" v-mask="['(##)####-####','(##)#####-####']">
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-5">
                <div class="form-group">
                  <label for="responsavel">Responsável</label>
                  <input
                    class="form-control"
                    name="responsavel"
                    type="text"
                    v-model="dados.responsavel"
                  >
                </div>
              </div>

              <div class="col-sm-5">
                <div class="form-group">
                  <label for="franqueado">Franqueado</label>
                  <v-select :disabled="true" v-model="franqueadoSelecionado" :options="franqueados"></v-select>
                </div>
              </div>

              <div class="col-sm-2">
                <div class="form-group">
                  <label for="comissao">Comissão</label>
                   <money class="form-control" v-model="dados.comissao_franqueado" v-bind="taxa"></money>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6">
               <div :class="{'form-group': true }">
                  <label for="antecipa">Permite Antecipação?</label>
                  <select class="form-control" name="antecipa" v-model="dados.antecipa">
                    <option value="N">NÃO</option>
                    <option value="S">SIM</option>
                  </select>
                </div>
              </div>
							<div class="col-sm-6">
               <div :class="{'form-group': true }">
                  <label for="simula-venda">Permite simular venda com taxas?</label>
                  <select class="form-control" name="simula-venda" v-model="dados.simula_venda">
                    <option value="N">NÃO</option>
                    <option value="S">SIM</option>
                  </select>
                </div>
              </div>
            </div>
             <div class="row">
              <div class="col-sm-12">
                <h4>Definição de Custos e Limites</h4>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-2">
                <div class="form-group">
                  <label for="mensalidade">Mensalidade</label>
                   <money class="form-control" v-model="dados.mensalidade" v-bind="money"></money>
                </div>
              </div>

              <div class="col-sm-2">
                <div class="form-group">
                  <label for="mensalidade">Valor por Consulta</label>
                   <money class="form-control" v-model="dados.valor_consulta" v-bind="money"></money>
                </div>
              </div>

              <div class="col-sm-2">
                <div class="form-group">
                  <label for="mensalidade">Taxa Prorrata</label>
                   <money class="form-control" v-model="dados.taxa_prorrata" v-bind="taxa"></money>
                </div>
              </div>

              <div class="col-sm-2">
                <div class="form-group">
                  <label for="mensalidade">Limite Cpf/Cnpj</label>
                   <money class="form-control"  v-model="dados.limite_cpf_cnpj" v-bind="money"></money>
                </div>
              </div>

              <div class="col-sm-2">
                <div class="form-group">
                  <label for="mensalidade">Limite por Boleto</label>
                  <money class="form-control"  v-model="dados.limite_boleto" v-bind="money"></money>
                </div>
              </div>

              <div class="col-sm-2">
                <div class="form-group">
                  <label for="mensalidade">Taxa Antecipação</label>
                   <money :disabled="dados.antecipa == 'N'" class="form-control" v-model="dados.taxa_antecipacao" v-bind="taxa"></money>
                </div>
              </div>

							<div class="col-sm-2">
                <div class="form-group">
                  <label for="mensalidade">Quantidade máxima de parcelas</label>
                   <input type="number" class="form-control" v-model="dados.qtd_max_parcelas"/>
                </div>
              </div>

            </div>
          </div>
          <div class="box-footer text-right">
            <router-link tag="button" to="/administracao/empresas" class="btn btn-default">Cancelar</router-link>
            <button class="btn btn-primary" @click="salvar()">Salvar</button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import axios from "axios"; // Cliente para requisição http
import { mask } from "vue-the-mask";
import vSelect from 'vue-select'
import { Money } from "v-money";

export default {
  directives: { mask },
  data() {
    return {
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        precision: 2,
        masked: false
      },
      taxa: {
        decimal: ".",
        thousands: "",
        prefix: "",
        precision: 2,
        masked: false
      },
      dados: {
        cnpj: "",
        razao: "",
        fantasia: "",
        insc_estadual: "",
        cep: "",
        endereco: "",
        numero: "",
        complemento: "",
        bairro: "",
        cidade: "",
        uf: "",
        tel1: "",
        tel2: "",
        tel3: "",
        responsavel: "",
        franqueado_id: null,
        comissao_franqueado: 10,
        limite_cpf_cnpj: null,
        limite_boleto: null,
        valor_consulta: 3.50,
        mensalidade: 150.00,
        taxa_prorrata: 0.1,
        antecipa: 'N',
        taxa_antecipacao: null,
				qtd_max_parcelas: 12,
				simula_venda: 'N'
      },
      franqueadoSelecionado: null,
      franqueados: [
        {value: 'CA', label: 'Canada'},
        {value: 'BR', label: 'Brasil'}
      ]
    };
  },
  mounted() {
    this.$nextTick(() => {
      // this.$refs.consulta_cpf_cnpj.focus();
    });

    if (this.$route.params.idEmpresa) {
			this.getById(this.$route.params.idEmpresa);
			this.atualizacao = true;
		}
  },

  methods: {
    getById (id) {
			this.$store.commit('TOGGLE_LOADING');
			axios.get(`${this.$store.state.serverURI}/api/empresa/getById/` + id, this.$store.getters.getHeaderAuth).then(response => {
				this.dados = response.data;
      });
    },
    salvar() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$store.commit("TOGGLE_LOADING");
          if (this.atualizacao) {
            axios
              .post(
                `${this.$store.state.serverURI}/api/empresa/update/` +
                  this.dados.id,
                this.dados,
                this.$store.getters.getHeaderAuth
              )
              .then(response => {
                this.$store.commit("SHOW_ALERT_SUCCESS");
                this.$swal({
                  type: response.data.status == 200 ? "success":"error",
                 title: response.data.status == 200 ? "Tudo Certo!":"Ops! Ocorreu um erro.",
                  text: response.data.msg,
                  showConfirmButton: false,
                  timer: 1500
                });
                this.$router.push("/administracao/empresas");
              })
              .catch(error => {
                this.$store.commit("SHOW_ALERT_ERROR");
                console.log(error);
              });
          } else {
            axios
              .post(
                `${this.$store.state.serverURI}/api/empresa/create`,
                this.dados,
                this.$store.getters.getHeaderAuth
              )
              .then(response => {
                this.$store.commit("SHOW_ALERT_SUCCESS");
                this.$swal({
                  type: response.data.status == 200 ? "success":"error",
                  title: response.data.status == 200 ? "Tudo Certo!":"Ops! Ocorreu um erro.",
                  text: response.data.msg,
                  showConfirmButton: false,
                  timer: 1500
                });
                this.$router.push("/administracao/empresas");
              })
              .catch(error => {
                this.$store.commit("SHOW_ALERT_ERROR");
                console.log(error);
              });
          }
        }
        this.$store.commit("TOGGLE_LOADING");
        return false;
      });
    },
    getEndereco() {
      if (this.dados.cep && this.dados.cep != "") {
        this.$store.commit("TOGGLE_LOADING");
        axios
          .get(`https://viacep.com.br/ws/${this.dados.cep}/json/`)
          .then(response => {
            if (response.data.erro) {
              this.$swal({
                type: "warning",
                title: "Digite um CEP válido!",
                text: ""
              }).then(() => {
                this.dados.cep = "";
                this.dados.endereco = "";
                this.dados.bairro = "";
                this.dados.cidade = "";
                this.dados.uf = "";
                this.$refs.cep.focus();
              });
              return false;
            }

            this.dados.endereco = response.data.logradouro;
            this.dados.bairro = response.data.bairro;
            this.dados.cidade = response.data.localidade;
            this.dados.uf = response.data.uf;
            this.$store.commit("TOGGLE_LOADING");

            this.$refs.numero_endereco.focus();
          })
          .catch((e) => {
            console.log(e);
            this.$swal({
              type: "warning",
              title: "Não conseguimos buscar seu endereço!",
              text: "Por favor, digite um CEP válido!"
            });
          });
      }
    },
  },
  watch: {
    franqueadoSelecionado: function(val) {
      this.dados.franqueado_id = val.value;
    }
  },
  components: {
    vSelect,
    Money
  }
};
</script>
<style scoped>
input {
  text-transform: uppercase;
}
</style>



// WEBPACK FOOTER //
// form.vue?47f4d612